export const yAxisLabelProps = {
  dy: -30,
  angle: 0,
  position: "insideTopLeft",
};

export const WAFFLE_CHART_COLORS = [
  "#2196F3",
  "#4CAF50",
  "#FF9800",
  "#9C27B0",
  "#00BCD4",
  "#F44336",
  "#E91E63",
  "#FF5722",
  "#9E9E9E",
];
